import { render, staticRenderFns } from "./AdvertisementNotifications.vue?vue&type=template&id=3ad0ae87&"
import script from "./AdvertisementNotifications.vue?vue&type=script&lang=js&"
export * from "./AdvertisementNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AdvertisementNotifications.vue?vue&type=style&index=0&id=3ad0ae87&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports